import { WALLET_LABELS } from "@nexus-cross/crossx-design-system";
import { WALLET_REGISTRY, type WalletId } from "./constants";

/**
 * 커넥트 모달에서 마지막으로 고른 항목을 기록한다.
 *
 * 용도는 하나 — `WalletInfo`가 계정 라벨을 표시할 때의 폴백. 호출측이
 * `accountName` / `connectorName` / `connectorId` 를 전부 빼먹으면 계정 라벨이
 * 익명 "Account"로 떨어지는데, 사용자가 모달에서 직접 고른 지갑이 있다면 그
 * 이름을 쓰는 게 가장 정확하다. 리로드 후(모달을 다시 거치지 않는 자동 재연결)
 * 에도 유지돼야 하므로 localStorage에 남긴다.
 *
 * 명시 prop 보다 항상 아래 순위이므로, 값이 낡아도 호출측이 이름을 넘기는
 * 순간 무시된다.
 */
const STORAGE_KEY = "dappui.wcm.last-selected";

/** 소셜 로그인은 embedded 지갑으로 귀결되므로 브랜드명 하나로 묶는다. */
const SOCIAL_IDS = new Set(["google", "apple"]);

export function recordSelectedWallet(id: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // Private 모드 / 용량 초과 등. 폴백 품질 문제일 뿐이라 조용히 넘긴다.
  }
}

/**
 * 마지막 선택 항목의 표시 이름. 모달에 표기됐던 라벨을 그대로 돌려준다.
 * 기록이 없거나 레지스트리에 없는 id면 `undefined`.
 *
 * 브라우저 전용 — SSR 중에는 항상 `undefined`이므로 호출측은 effect 안에서
 * 읽어 hydration mismatch를 피해야 한다.
 */
export function readSelectedWalletName(): string | undefined {
  let id: string | null = null;
  try {
    id = window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return undefined;
  }
  if (!id) return undefined;
  if (SOCIAL_IDS.has(id)) return WALLET_LABELS.default;
  return WALLET_REGISTRY[id as WalletId]?.name;
}
